import type { FormBlock } from '@/components/UI/Form/types'

import { HOW_DID_YOU_HEAR_INPUT_NAME } from './constants'

export default function getHowDidYouHearFormInputs(): FormBlock[] {
  return [
    {
      label: 'How did you hear about Schoolhouse?',
      sublabel:
        'Please be as detailed as possible, including the names of any people or programs who recommended you. ' +
        'This will help us review your application.',
      type: 'textarea',
      name: HOW_DID_YOU_HEAR_INPUT_NAME,
      required: true,
      size: 6,
    },
  ]
}
